<script setup>
import ActivityTimeline from '@/components/activity/activity-timeline.vue'

defineProps({
  // one of the {lead|customer|vendor} blocks from /api/message/contact-match
  data: {type: Object, required: true},
})

const KIND_LABEL = {lead: 'Lead', customer: 'Customer', vendor: 'Vendor'}
</script>

<template>
  <div class="h-100 d-flex flex-column">
    <div class="mb-2">
      <div class="d-flex align-items-baseline">
        <b-badge variant="secondary" class="mr-2">{{ KIND_LABEL[data.kind] || data.kind }}</b-badge>
        <b-link :href="data.route" target="_blank" class="font-weight-bold">{{ data.gli }}</b-link>
        <font-awesome-icon :icon="['fas', 'arrow-up-right-from-square']" class="ml-1 small text-muted"/>
        <b-badge v-if="data.do_not_contact" variant="danger" class="ml-2">Do Not Contact</b-badge>
      </div>
      <div v-if="data.name" class="small">{{ data.name }}</div>
      <div v-if="data.company" class="small text-muted">{{ data.company }}</div>
      <div v-if="data.title" class="small text-muted">{{ data.title }}</div>
      <div v-if="data.status_desc" class="small text-muted">Status: {{ data.status_desc }}</div>
      <div v-if="data.event" class="small text-muted">Event: {{ data.event.name || data.event.gli }}</div>
    </div>

    <div class="flex-fill overflow-auto">
      <activity-timeline v-if="data.activity_url" :url="data.activity_url"
                         :write-allowed="!!data.activity_write" height="240px"/>
    </div>
  </div>
</template>
